import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {QualityCheck, QualityControllerService} from "../api";
import {StateConfigService} from "../services/state/state-config.service";

@Injectable({
  providedIn: 'root'
})
export class QualityCheckResolver {
  private stateConfigService = inject(StateConfigService);
  private qualityControllerService = inject(QualityControllerService);


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<QualityCheck> {
    const id = route.paramMap.get('checkId')

    return this.qualityControllerService.getCheck(id!, this.stateConfigService.getProjectId())

  }
}
